import React from 'react';
import withIcon from '../utilities/withIcon';

const IconClone = () => {
  return (
    <g>
      <path d="M12 1a1 1 0 0 1 1 1v2h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h11zm2.5 4.5h-10v8h10v-8zm-3-1.5V2.5h-10v8H3V5a1 1 0 0 1 1-1h7.5z" />
    </g>
  );
};

export default withIcon(IconClone);
